export enum RseeActionTypeEnum {
  RSEE_DOCUMENT_ADDITION,
  RSEE_DOCUMENT_UPDATE,
}
